"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createForceStateMatchers = exports.DOMLocationBasedPseudoClasses = void 0;
const css_selector_parser_1 = require("@tokey/css-selector-parser");
exports.DOMLocationBasedPseudoClasses = new Set([
    'root',
    'first-child',
    'first-of-type',
    'last-child',
    'last-of-type',
    'nth-child',
    'nth-last-child',
    'nth-last-of-type',
    'nth-of-type',
    'only-child',
    'only-of-type',
]);
function createForceStateMatchers(selector) {
    const ast = (0, css_selector_parser_1.parseCssSelector)(selector);
    const chunks = separateStateChunks(ast);
    const forces = [];
    for (let i = 0; i < chunks.length; i++) {
        const selectorChunks = chunks[i];
        const selectorForces = [];
        forces.push(selectorForces);
        for (let j = 0; j < selectorChunks.length; j++) {
            const relevantChunks = selectorChunks.slice(0, j + 1);
            const lastTarget = relevantChunks[relevantChunks.length - 1];
            selectorForces.push({
                states: lastTarget.states,
                selector: (0, css_selector_parser_1.stringifySelectorAst)(mergeStateChunks([relevantChunks])),
            });
        }
    }
    return forces;
}
exports.createForceStateMatchers = createForceStateMatchers;
function mergeStateChunks(chunks) {
    const ast = [];
    let i = 0;
    for (const selectorChunks of chunks) {
        ast[i] = {
            type: 'selector',
            nodes: [],
            start: 0,
            end: 0,
            before: selectorChunks.length ? selectorChunks[0].before : ``,
            after: ``,
        };
        for (const chunk of selectorChunks) {
            if (chunk.cause) {
                ast[i].nodes.push(chunk.cause);
            }
            for (const node of chunk.nodes) {
                ast[i].nodes.push(node);
            }
        }
        i++;
    }
    return ast;
}
function separateStateChunks(selectorList) {
    const selectors = [];
    selectorList.map(({ nodes, before }) => {
        selectors.push([{ cause: null, before, nodes: [], states: [] }]);
        nodes.forEach((node) => {
            if (node.type === 'combinator') {
                const chunks = selectors[selectors.length - 1];
                chunks.push({ cause: node, before: ``, nodes: [], states: [] });
            }
            else if (node.type === 'pseudo_class' &&
                !exports.DOMLocationBasedPseudoClasses.has(node.value) &&
                node.value !== 'not') {
                const chunks = selectors[selectors.length - 1];
                const current = chunks[chunks.length - 1];
                current.states.push({
                    type: `pseudo-class`,
                    name: node.value,
                });
            }
            else if (node.type === 'pseudo_element') {
                const chunks = selectors[selectors.length - 1];
                chunks.push({ cause: node, before: ``, nodes: [], states: [] });
            }
            else {
                const chunks = selectors[selectors.length - 1];
                chunks[chunks.length - 1].nodes.push(node);
            }
        });
    });
    return selectors;
}
//# sourceMappingURL=create-forcestate-matchers.js.map